import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

const PageResearchCommunicationFormListInitizializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={{}}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageResearchCommunicationFormListInitizializer.displayName =
  'Page Research Communication Form List Initizializer Component';

export default PageResearchCommunicationFormListInitizializer;
